import { render, staticRenderFns } from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=template&id=4e797b0e&scoped=true"
import script from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=script&lang=js"
export * from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e797b0e",
  null
  
)

export default component.exports